import { AlertCircle, Loader2, RefreshCw } from "lucide-react";
import type { LoadStatus } from "./adminApi";

export function AdminState({
  children,
  emptyText,
  emptyTitle = "Nothing here yet",
  error,
  loadingText = "Loading live data",
  onRetry,
  status,
}: {
  children: React.ReactNode;
  emptyText: string;
  emptyTitle?: string;
  error?: string;
  loadingText?: string;
  onRetry?: () => void;
  status: LoadStatus;
}) {
  if (status === "loading") {
    return (
      <section className="wr-panel wr-state-panel" aria-live="polite">
        <Loader2 className="wr-spin" size={18} aria-hidden />
        <strong>{loadingText}</strong>
        <div className="wr-skeleton-stack" aria-hidden>
          <span />
          <span />
          <span />
        </div>
      </section>
    );
  }

  if (status === "error") {
    return (
      <section className="wr-panel wr-state-panel wr-state-panel--error" aria-live="polite">
        <AlertCircle size={18} aria-hidden />
        <strong>Unable to load live data</strong>
        <p>{error ?? "The admin API did not return a usable response."}</p>
        {onRetry ? (
          <button className="wr-button wr-button--secondary" type="button" onClick={onRetry}>
            <RefreshCw size={15} aria-hidden />
            Retry
          </button>
        ) : null}
      </section>
    );
  }

  if (status === "empty") {
    return (
      <section className="wr-panel wr-state-panel" aria-live="polite">
        <strong>{emptyTitle}</strong>
        <p>{emptyText}</p>
      </section>
    );
  }

  return <>{children}</>;
}
